import React from 'react'

export function BaseModalFooter({children}) {
  return (
    <div className="flex justify-end gap-4 p-swivu-base border-t border-border border-solid w-full">
      {children}
    </div>
  )
}